import { asyncActionCreators, actionCreator } from '../../utils/actions';

export const changeCurrentDeviceState = actionCreator('CHANGE_CURRENT_DEVICE_STATE');
export const fetchDevices = asyncActionCreators('FETCH_DEVICES');
export const fetchDevicesStats = asyncActionCreators('FETCH_DEVICES_STATS');
export const lockDoors = asyncActionCreators('Device/LOCK_DOORS');
export const toggleIgnition = asyncActionCreators('Device/TOGGLE_IGNITION');
export const toggleTrunk = asyncActionCreators('Device/TOGGLE_TRUNK');
export const toggleServiceMode = asyncActionCreators('Device/TOGGLE_SERVICE_MODE');
export const toggleWebasto = asyncActionCreators('Device/TOGGLE_WEBASTO');
export const setAutorunEngineDelaySeconds = asyncActionCreators('DEVICE/POST_AUTORUN_ENGINE_DELAY_IN_SECONDS');
export const setWebastoPeriodSeconds = asyncActionCreators('DEVICE/POST_WEBASTO_PERIOD_IN_SECONDS');
export const setTooltip = actionCreator('Device/SET_TOOLTIP');
export const clearTooltip = actionCreator('Device/CLEAR_TOOLTIP');
export const resetDeviceLockDoors = actionCreator('Device/RESET_LOCK_DOORS');
export const resetDeviceToggleIgnition = actionCreator('Device/RESET_TOGGLE_IGNITION');
export const toggleIgnitionResult = actionCreator('Device/TOGGLE_IGNITION_RESULT');
export const lockDoorsResult = actionCreator('Device/LOCK_DOORS_RESULT');
export const unlockTrunkResult = actionCreator('Device/UNLOCK_TRUNK_RESULT');
export const resetDeviceUnlockTrunk = actionCreator('Device/RESET_UNLOCK_TRUNK');
export const holdDown = 'Device/HOLD_DOWN';



// WEBPACK FOOTER //
// ./src/sagas/devices/actions.js